<template>
  <div class="event-pitch-container">
    <div class="edit-form-title">
      <h1>Pitch your Event</h1>
      <div class="package-header-note">
        Craft the pitch for your event so that sponsors understand what you can offer to them.
        Remember, sponsors are typically businesses with a limited marketing budget.
        Try to communicate meaningful business outcomes.
      </div>
    </div>
    <div class="edit-form edit-form-margin-top">
      <label>Describe Your Event
        <tooltip>
          Provide relevant information about your event.
          What is it? Who will be there? What business outcomes can you offer to sponsors?
          Why will those outcomes help them grow their brand? (Learn More)
        </tooltip>
      </label>
      <rich-text-editor
        @ready="bus.$emit('insertHTML', pitch)"
        :bus="bus"
        :eventId="eventId"
        @change="data => pitch = data">
        </rich-text-editor>
    </div>
    <div class="edit-form edit-form-margin-top">
      <label class="common-questions-title">Commonly Asked Questions</label>
      <div class="common-questions-container">
        <button aria-label="Add Common Questions" v-for="(question, i) in commonQuestions"
          :key="i"
          @click="bus.$emit('insertHTML', `<br/><h3>${question}</h3>`)"
          class="common-question">
          {{question}}
        </button>
      </div>
    </div>
    <div class="edit-form">
      <button class="button" aria-label="Next" @click="goNext">Next</button>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapState } from 'vuex';
import RichTextEditor from '@/components/RichTextEditor.vue';
import debounce from 'lodash/debounce';

const Bus = new Vue();
export default {
  name: 'event-pitch',
  components: {
    RichTextEditor,
  },
  data() {
    return {
      eventId: null,
      bus: Bus,
      commonQuestions: [
        'Who are we?',
        'Why are we doing this?',
        'What is available for corporate sponsorship?',
        'Describe in detail about the Event Venue?',
        'Describe the layout of the booth space, photo(if any)?',
        'Where can sponsor find information on the Speakers of this event?',
        'What are the Speakership Opportunities',
        'From where can sponsor know about the attendees that are coming to this event?',
        'Which all companies have associated with this event/or are currently sponsoring this event?',
        'Who were the past sponsors',
        'Is this a global event and what was the success you had in the past',
        'Till when can sponsor send their Marketing material for event bag insertions?',
        'What are the benefits and rights of sponsors?',
        'What return of investment should brands expect from the sponsorship?',
        'When will be the Participant list would be sent to the sponsor?',
        'How many sponsors confirmed until now?',
        'What is the level of media coverage?',
      ],
      pitch: '',
    };
  },
  computed: {
    ...mapState('auth', ['backendAxios']),
  },
  created() {
    this.debouncedSave = debounce(this.save, 2000);
  },
  async mounted() {
    this.eventId = this.$route.params.eventId;
    try {
      const eventResponse = await this.backendAxios
        .get(`/sponsorship-event/my-event/id/${this.eventId}?fields=pitch`);
      this.pitch = decodeURI(eventResponse.data.pitch || '');
      this.bus.$emit('insertHTML', this.pitch);
    } catch (err) {
      this.$toasted.show(err.response.data, {
        type: 'info',
        duration: 5000,
      });
    }
    const unwatchPitch = this.$watch(() => this.pitch, () => {
      this.debouncedSave();
    });
    this.$once('hook:destroyed', () => {
      unwatchPitch();
    });
  },
  methods: {
    async save() {
      try {
        const params = {
          pitch: encodeURI(this.pitch),
        };
        await this.backendAxios
          .put(`/sponsorship-event/my-event/id/${this.eventId}`, params);
        return true;
      } catch (err) {
        this.$toasted.show(err.response.data, {
          type: 'info',
          duration: 5000,
        });
      }
      return false;
    },
    async goNext() {
      this.debouncedSave.cancel();
      if (await this.save()) {
        this.$emit('next', this.$route.name);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/youpaired-colors.scss';

.common-questions-title {
  margin-top: 1rem;
}

.common-questions-container {
  box-sizing: border-box;
  margin: 0 auto;
  width: 100%;
  padding: 1rem;
  border: 1px solid lightgray;
}

.common-question {
  text-align: left;
  width: 100%;
  color: #002f8a;
  cursor: pointer;
  margin: 0.5rem 0;
  padding: 0;
  text-decoration: none;
  border: none;
  font-size: 0.875rem;
  font-weight: 500;
  background-color: transparent;
  &:hover {
    text-decoration: underline;
  }
}
</style>
